import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { withAppState } from "../../state";
import { withRouter } from "react-router-dom";
import getMediaItems from "./mediaItems";
import { MediaControls, MediaItem } from "../../services/visualLibraryService";
import { i18n } from "../../services/i18nService";
import { starzRevamp as theme } from "starz-visual-themes";
import { resolution } from "../../config/ui/resolutionConfig";

let carousel;
let menuFocused = false;
export const defaultFocusPath = "mediaControls";

class MediaControlsList extends Component {
  constructor(props) {
    super(props);
    this.items = [];
    this.navigate = this.navigate.bind(this);
    this.handleNavigation = this.handleNavigation.bind(this);

    this.state = {
      isLogged: props.applicationState.userLogged,
      mediaFocusedIndex: props.applicationState.focusedMediaControlItemIndex,
      mediaItemCount: 0
    };
  }

  navigate() {
    const item = getMediaItems()[this.state.menuFocusedIndex];
    const action = item.isRoot ? this.props.history.replace : this.props.history.push;
    if (item.callback) {
      const returnValue = item.callback.call(this);
      if (returnValue) {
        return;
      }
    }
    action(item.path, { preserveFocus: item?.isRoot });
  }

  left() {
    carousel.left();
  }

  right() {
    carousel.right();
  }

  down() {
    carousel.down();
  }

  rightMenuHandler() {
    this.props.setFocus("lists");
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      menuFocused === false ||
      this.props.focused !== nextProps.focused ||
      this.props.mediaControlMenu !== nextProps.mediaControlMenu ||
      this.state.isLogged !== nextProps.applicationState.userLogged ||
      this.state.isLogged !== nextState.isLogged ||
      this.state.mediaFocusedIndex !== nextProps.applicationState.focusedMediaControlItemIndex ||
      this.state.mediaFocusedIndex !== nextState.mediaFocusedIndex ||
      this.parentalLevel !== nextProps.applicationState.parentalLevel
    );
  }

  componentDidMount() {
    this.setState({
      isLogged: this.props.applicationState.userLogged,
      mediaFocusedIndex: this.props.applicationState.focusedMediaControlItemIndex,
      mediaItemCount: (getMediaItems() || []).length || 0
    });
    this.parentalLevel = this.props.applicationState.parentalLevel;
    this.props.onRef && this.props.onRef(this);
  }

  componentDidUpdate() {
    const {
      applicationState: { focusedMediaControlItemIndex, userLogged, parentalLevel }
    } = this.props;

    //handleFocus(focused);
    if (
      this.state.isLogged !== userLogged ||
      this.state.mediaFocusedIndex !== focusedMediaControlItemIndex ||
      this.parentalLevel !== parentalLevel
    ) {
      this.parentalLevel = parentalLevel;
      this.setState({
        isLogged: userLogged,
        mediaFocusedIndex: focusedMediaControlItemIndex
      });
    }
    menuFocused = true;
  }

  componentWillUnmount() {
    menuFocused = false;
  }

  handleNavigation(index) {
    this.props.stateActions.setMediaControlItemFocus(index);
  }

  checkInitialSlideIndex() {
    const {
      applicationState: { focusedMediaControlItemIndex }
    } = this.props;
    let index = focusedMediaControlItemIndex > getMediaItems().length - 1 ? 0 : focusedMediaControlItemIndex;
    //index = (getMediaItems() || []).findIndex(values => values.path === location.pathname);
    this.props.applicationState.focusedMediaControlItemIndex = index;
  }

  hide() {
    return carousel?.hide();
  }
  show() {
    return carousel?.show();
  }

  render() {
    const { isLogged } = this.state;
    const { initialSlideIndex = 0 } = this.props;
    //const menu = getMediaItems();
    const menu = this.props.mediaControlMenu;
    //this.checkInitialSlideIndex();

    return (
      <MediaControls
        ref={ref => (carousel = ref)}
        direction={i18n.getDirection()}
        onChange={this.handleNavigation}
        initialSlide={initialSlideIndex}
      >
        {menu &&
          menu.map((item, index) => {
            return (
              <MediaItem
                key={`item_${item.name}_${index}_${new Date().getTime()}`}
                to={item.path}
                label={item.name && i18n.get(`global.sections.${item.name}`)}
                icon={index === this.state.mediaFocusedIndex ? `${item.icon}_focused` : item.icon}
                use={NavLink}
                fill={index !== this.state.mediaFocusedIndex ? theme.color.greyMedium : ""}
                opacity={index === this.state.mediaFocusedIndex ? 1 : 0.6}
                isLogged={isLogged}
                onRef={ref => this.items.push(ref)}
                focused={index === this.state.mediaFocusedIndex ? 1 : 0}
                title={item.title}
              />
            );
          })}
      </MediaControls>
    );
  }
}

export default withRouter(withAppState(MediaControlsList));
